import type { ResourceProps } from 'react-admin';
import SellIcon from '@mui/icons-material/Sell';

import PricingRulesList from './PricingRulesList';
import PricingRulesCreate from './PricingRulesCreate';
import PricingRulesEdit from './PricingRulesEdit';

export { pricingRulesDataProvider } from './dataProvider';
export { default as PricingRulesHistory } from './PricingRulesHistory';

const resource: ResourceProps = {
  name: 'resalePricing/pricingRules',
  list: PricingRulesList,
  create: PricingRulesCreate,
  edit: PricingRulesEdit,
  icon: SellIcon,
  options: { label: 'Price Rules' },
};

export default resource;
